<template>
    
        <div class="col-sm-4">

            <div class="make-offer-container">
                  <div class="make-offer-details">
                    <div class="header d-flex">
                      <p><span class="naira font-bold font-md"></span>
                       {{ crop ? crop.kg_price / 0.001 : '***' | formatNumber }} <span>per ton</span></p>
                    </div>
                  </div>
                  <div class="make-offer-form">
                    <p class="alert alert-success text-center mb-2" v-if="message">{{message}}</p>
                    <form @submit.prevent="submitquantity">
                      <div class="form-group">
                        <div class="make-offer-input-group">
                          <input type="text" placeholder="E.g 1000" :max="availableQty"
                          v-model="quantity" @keyup="changeValue" required />
                          <div class="measurement">tons</div>
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="make-offer-input-group is-disabled input-is-disabled">
                          <p>{{nairaValue | formatNumber }}</p>
                          <div class="measurement">Naira</div>
                        </div>
                      </div>
                      <div class="form-group">
                        <submit-button class="btn btn-block btn-secondary" :disabled="checkField" :loading="loading">
                          Add to cart
                        </submit-button>
                      </div>
                    </form>
                  </div>
                  <div class="make-offer-footer">
                    <div class="make-offer-tip">
                      <svg width="5" height="10" viewBox="0 0 5 10" fill="none" xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M4.00006 8.99995C3.80425 9.01827 3.60777 8.97266 3.44006 8.86995C3.37924 8.8049 3.3334 8.72733 3.30576 8.64268C3.27812 8.55803 3.26935 8.46835 3.28006 8.37995C3.2689 8.24017 3.2689 8.09973 3.28006 7.95995C3.28006 7.76995 3.35006 7.60995 3.39006 7.45995L4.00006 5.65995C4.05166 5.48041 4.08516 5.29616 4.10006 5.10995C4.10006 4.90995 4.10006 4.76995 4.10006 4.68995C4.10586 4.51506 4.07303 4.34104 4.00389 4.18029C3.93475 4.01954 3.83101 3.87602 3.70006 3.75995C3.38012 3.50574 2.97808 3.37766 2.57006 3.39995C2.27404 3.40462 1.98055 3.45522 1.70006 3.54995C1.39339 3.64995 1.06006 3.76662 0.700058 3.89995L0.560059 4.45995L1.00006 4.33995C1.13312 4.30029 1.27121 4.28008 1.41006 4.27995C1.60421 4.25966 1.79923 4.3093 1.96006 4.41995C2.01471 4.48827 2.05522 4.56677 2.07926 4.65089C2.10329 4.73501 2.11036 4.82307 2.10006 4.90995C2.1141 5.05294 2.1141 5.19696 2.10006 5.33995C2.10006 5.48995 2.03006 5.65995 1.98006 5.83995L1.46006 7.65995C1.46006 7.84995 1.38006 8.01995 1.36006 8.16995C1.35 8.31978 1.35 8.47012 1.36006 8.61995C1.35478 8.79572 1.38886 8.97045 1.4598 9.13135C1.53074 9.29226 1.63674 9.43528 1.77006 9.54995C2.09778 9.81227 2.51097 9.94407 2.93006 9.91995C3.21864 9.92409 3.5059 9.88016 3.78006 9.78995L4.78006 9.41995L4.92006 8.85995L4.46006 8.99995C4.30751 9.02183 4.15261 9.02183 4.00006 8.99995Z"
                          fill="#757575" />
                        <path d="M3.71007 2.35997C4.03309 2.35856 4.34237 2.22909 4.57007 1.99997C4.68358 1.89776 4.77434 1.77284 4.83646 1.6333C4.89859 1.49376 4.93069 1.34272 4.93069 1.18997C4.93069 1.03723 4.89859 0.886187 4.83646 0.746647C4.77434 0.607107 4.68358 0.482182 4.57007 0.379971C4.33973 0.157242 4.03045 0.0349676 3.71007 0.0399713C3.38665 0.034497 3.07408 0.156649 2.84007 0.379971C2.72568 0.481424 2.63435 0.606216 2.57225 0.74594C2.51015 0.885664 2.47872 1.03707 2.48007 1.18997C2.47806 1.34297 2.5092 1.49459 2.57134 1.63441C2.63348 1.77423 2.72516 1.89894 2.84007 1.99997C3.07146 2.22969 3.38402 2.35902 3.71007 2.35997Z"
                          fill="#757575" />
                      </svg>
                    </div>

                    <p>
                      You will not be charged until the farmer accepts your order.
                    </p>
                  </div>
                </div>
            
        </div>
    
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    props: ['crop'],
    data() {
        return {
            quantity: '',
            nairaValue: 0,
            message: '',
            loading: false
        }
    },
    computed: {
        ...mapState('offtaker',['cart']),
        checkCartQty() {
            if(this.cart.length !== 0) {
            const arr = this.cart.filter(item => item.id === this.crop.id)
            // console.log('Filter ', arr)
            const total = arr.reduce((sum, item) => {
                return sum + Number(item.quantity)
            }, 0)
            return total;
            } else {
                return 0
            }
        },
        checkField() {
            if(this.qunatity === '' || 
            Number(this.quantity) > Number(this.availableQty) 
            || Number(this.quantity) === 0 ) {
            return true
            }
            return false
        },
        availableQty() {
            return this.crop ? (this.crop.kg_yield - this.crop.kg_sold) / 1000 : ''
        },
        estYield() {
            return this.crop.kg_yield / 1000
        }
    },
    methods: {
        ...mapActions('offtaker', { 
            toCart:'addToCart'
        }),
        changeValue() {
            this.nairaValue = Number(this.quantity) * (this.crop.kg_price/0.001)
        },
        

        submitquantity() {
          this.saveItem();
            // const obj = {...this.crop}
            // obj.quantity = Number(this.quantity);
            // obj.totalValue = Number(this.nairaValue);
            // obj.cartId = this.cart.length + 1

            // this.toCart(obj)
            // this.quantity = ''
            // this.nairaValue = ''
            // this.message = 'Added to cart';
            // // this.$toastr.success('Added to cart')
            // this.clear()
            // // this.$emit('reCheckQty')
        },
        saveItem() {
          this.loading = true;
          const formData = {
            crop_id: this.crop.id,
            quantity: this.quantity * 1000
          }
          this.$http.post('cart_items', formData)
          .then((response) => {
            this.getCartItems();
          })
          .catch((error) => {
            this.$toastr.error(error)
          })
        },
        getCartItems() {
          this.$http.get('cart_items')
          .then((response) => {
            this.toCart(response.data)
          })
          .catch((error) => {
            this.$toastr.error(error)
          })
          .finally(() => {
            this.loading = false;
            this.message = 'Added to cart';
            this.quantity = ''
            this.nairaValue = ''
            this.clear();
          })
        },
        clear() {
            setTimeout(() => {
                this.message = ''
            }, 5000)
        }
    }
}
</script>

<style>

</style>
